export default __webpack_public_path__ + "static/media/26w.74955203.svg";